document.addEventListener('click', (event) => {
  const toggleButton = event.target.closest('[data-action="toggle-sizes"]');
  const openSelector = document.querySelector('.product-card__floating-size-selector.is-visible-on-touch');

  if (!toggleButton && openSelector && !event.target.closest('.product-card__floating-size-selector')) {
    openSelector.style.opacity = '';
    openSelector.style.visibility = '';
    openSelector.style.transform = '';
    openSelector.classList.remove('is-visible-on-touch');
    document.querySelectorAll('[data-action="toggle-sizes"]').forEach(btn =>
      btn.classList.remove('is-hidden-while-sizes-visible')
    );
    return;
  }

  if (!toggleButton) return;

  const productCard = toggleButton.closest('.product-card');
  if (!productCard) return;

  const sizeSelector = productCard.querySelector('.product-card__floating-size-selector');
  if (!sizeSelector) return;

  document.querySelectorAll('.product-card__floating-size-selector').forEach(selector => {
    if (selector !== sizeSelector) {
      selector.style.opacity = '';
      selector.style.visibility = '';
      selector.style.transform = '';
      selector.classList.remove('is-visible-on-touch');
    }
  });
  document.querySelectorAll('[data-action="toggle-sizes"]').forEach(btn =>
    btn.classList.remove('is-hidden-while-sizes-visible')
  );

  const isNowOpen = !sizeSelector.classList.contains('is-visible-on-touch');
  if (isNowOpen) {
    sizeSelector.style.opacity = '1';
    sizeSelector.style.visibility = 'visible';
    sizeSelector.style.transform = 'translateY(0px)';
    sizeSelector.classList.add('is-visible-on-touch');
    toggleButton.classList.add('is-hidden-while-sizes-visible');
  } else {
    sizeSelector.style.opacity = '';
    sizeSelector.style.visibility = '';
    sizeSelector.style.transform = '';
    sizeSelector.classList.remove('is-visible-on-touch');
    toggleButton.classList.remove('is-hidden-while-sizes-visible');
  }
});